import { writable } from 'svelte/store';
export const userSignedIn = writable(false);
export const userName = writable("");
export const userData = writable({});
export const documents = writable([]);
export const currentRoute = writable('/'); // The default route is home
export const showOverlay = writable(false);
export const paraphraseOptions = writable([]);
export const synonymOptions = writable([]);
export const selectedText = writable("");
export const promoCodeValue = writable("");
export const validatedPromoCode = writable("");
export const isLoading = writable(false);
export const apiData = writable({});
